import React from 'react';
import DefaultIcon from '@/assets/app-logo.png';
import store from '@/store';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
}

const DefaultAppIcon = (props: IProps) => {
  const [siteSettingsState] = store.useModel('siteSettings');

  return (
    <img
      className={props.className}
      style={props.style}
      src={
        siteSettingsState?.miniappDefaultIcon ? siteSettingsState?.miniappDefaultIcon : DefaultIcon
      }
    />
  );
};

export default DefaultAppIcon;
